import { Close as CloseIcon } from "@mui/icons-material";
import { Box, SxProps, Tooltip, Typography } from "@mui/material";
import React, { FunctionComponent } from "react";
import theme from "styles/theme";



interface Props {
	label?: string
	icon?: React.ReactNode
	tooltip?: string
	disabled?: boolean
	active?: boolean
	noClear?: boolean
	onClick?: (e: React.MouseEvent) => void
	onClear?: (e: React.MouseEvent) => void
	sx?: SxProps
}

/**
 * picker per una range di tipo DateRange
 */
const Chip: FunctionComponent<Props> = ({
	label,
	icon,
	tooltip,
	disabled = false,
	active,
	noClear,
	onClick,
	onClear,
	sx,
}) => {

	// HOOKs

	// HANDLERs

	// RENDER 
	return <Box
		sx={[sxChip(active, disabled), sx as any]}
		onClick={!disabled ? onClick : undefined}
	>
		<Tooltip title={tooltip}>
			<Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
				{icon}
				<Box sx={sxLabel}>
					{label}
				</Box>
			</Box>
		</Tooltip>
		{active && !noClear && <CloseIcon sx={{ width: "14px" }} onClick={onClear} />}
	</Box>
}

export default Chip

const sxChip = (haveValue: boolean, disabled: boolean): SxProps => ({
	display: "flex", alignItems: "center", gap: "2px",
	height: "22px",
	borderRadius: "10px",
	padding: "2px 8px",
	color: "#000",

	cursor: disabled ? undefined : "pointer",
	backgroundColor: haveValue ? theme.palette.secondary.main : theme.palette.grey.light,
	opacity: disabled ? 0.5 : 1,
})

const sxLabel: SxProps = {
	display: "flex",
	fontSize: 12,
	fontWeight: 500,
	maxWidth: "150px",
	overflow: "hidden",
	textOverflow: "ellipsis",
	whiteSpace: "nowrap",
}